import './IconFavorite.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconFavorite = function IconFavorite(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 18 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 18",
    className: className
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19.972",
    height: "17.753",
    viewBox: "0 0 19.972 17.753"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.746,10l-6.759,6.646L4.228,10a3.325,3.325,0,0,1,0-4.771,3.559,3.559,0,0,1,4.957,0l.244.241L10.986,7l1.559-1.537.241-.239a3.56,3.56,0,0,1,4.96,0,3.331,3.331,0,0,1,0,4.771M19.3,3.642a5.78,5.78,0,0,0-8.071,0l-.244.242-.244-.242a5.778,5.778,0,0,0-8.07,0,5.544,5.544,0,0,0,0,7.936l8.314,8.175L19.3,11.578a5.547,5.547,0,0,0,0-7.936",
    transform: "translate(-1 -2)"
  })));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "sq69x8x"
});
export default IconFavorite;